import BaseView from './_BaseView.js';
import Table from "../components/Table";
import Api from "../Api";
import Confirm from "../components/Confirm";

export default class RolesView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#roleForm';
        this.formUrl = '/api/role';
        this.formTpl = 'role-form-simple';
        this.formTitle = Lang.role;
        this.defaultObject = {
            title: '',
            description: ''
        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    init() {
        super.init();
        // const cards = new Card($('#roles'), {
        //     url: '/api/role',
        //     tpl: 'roles',
        //     formTpl: 'role-form',
        //     default: {
        //         title: 'New Role',
        //         description: ''
        //     },
        //     getFormData: function($form) {
        //         return $form.aeroSerialize();
        //     }
        // });
        // cards.init();
        if ($('#roleTable').length > 0) {
            this.table = new Table('roleTable', '/api/role/table', [
                {data: 'title', orderable: true},
                {data: 'description'},
                {data: 'pathways', orderable: false},
                {data: 'guides', orderable: false},
                {data: 'smartRole', orderable: false},
                {data: 'tools', orderable: false},
            ]);
        }
    }

    getFormData() {
        const data = super.getFormData();
        data.hideConsole = !!(data.hideConsole);
        return data;
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const roles = $('#roleTable');

        roles.on('click', '.edit', function () {
            if ($(this).hasClass('disabled')) {
                return false;
            }
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/role/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        // delete
        roles.on('click.appdel', '.delete', function () {
            if ($(this).hasClass('disabled')) {
                return false;
            }
            const id = $(this).parents('div:eq(0)').data('id');
            Confirm({
                ok: Lang.delete,
                title: name,
                msg: `${Lang.delsure}<br><br><strong class="msg-box danger">${Lang.delundone}</strong>`,
                onConfirm: function () {
                    Api.send(`/api/role/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });
        });

        $('.add-role-form').on('click', function () {
            self.renderForm();
            return false;
        });
    }
}
